import React from "react";
import "../assets/styles/Navigation.scss";

const NAV_ITEMS: [string, string][] = [
  ["Mən kiməm?", "#about"],
  ["Layihələr", "#projects"],
  ["Karyera", "#history"],
  ["Əlaqə", "#contact"],
];

type NavProps = {
  theme: "dark" | "light";
  toggleTheme: () => void;
};

function Navigation({ theme, toggleTheme }: NavProps) {
  return (
    <nav className="pill-nav" aria-label="Naviqasiya">
      {NAV_ITEMS.map(([label, href]) => (
        <a key={href} href={href} className="pill-link">
          {label}
        </a>
      ))}
      <span className="pill-divider" />
      <button
        type="button"
        className="pill-toggle"
        onClick={toggleTheme}
        aria-label="Tema dəyişdir"
      >
        {theme === "dark" ? (
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <circle cx="12" cy="12" r="4" />
            <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
          </svg>
        ) : (
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
          </svg>
        )}
      </button>
    </nav>
  );
}

export default Navigation;
